import { LAYOUTS, BREAKPOINTS } from './constants';

/** @deprecated */
export const determineLayout = (size: number): LAYOUTS => {
  if (size <= BREAKPOINTS[LAYOUTS.MOBILE].MAX) {
    return LAYOUTS.MOBILE;
  }

  if (size <= BREAKPOINTS[LAYOUTS.TABLET].MAX) {
    return LAYOUTS.TABLET;
  }

  if (size <= BREAKPOINTS[LAYOUTS.DESKTOP].MAX) {
    return LAYOUTS.DESKTOP;
  }

  return LAYOUTS.DESKTOP_WIDE;
};
